/**
 * 国优炬康 后台 v-permission 指令
 *
 * 用法:
 *   <button v-permission="'CONTENT_ARTICLE_EDIT'">编辑</button>
 *   <div v-permission="['CONTENT_ARTICLE_LIST', 'CONTENT_ARTICLE_EDIT']">内容区</div>
 *
 * 无权限时元素自动隐藏
 */

import type { Directive, DirectiveBinding } from 'vue';
import type { AdminPermission } from '@gyjk/shared';

import { useAuthStore } from '@/stores/auth';

function check(permissions: AdminPermission | AdminPermission[]): boolean {
  const auth = useAuthStore();
  if (!auth.isLoggedIn) return false;
  if (auth.permissions.includes('*')) return true;
  const list = Array.isArray(permissions) ? permissions : [permissions];
  return list.some((p) => auth.permissions.includes(p));
}

function update(el: HTMLElement, binding: DirectiveBinding<AdminPermission | AdminPermission[]>): void {
  const ok = check(binding.value);
  el.style.display = ok ? '' : 'none';
}

export const permissionDirective: Directive<HTMLElement, AdminPermission | AdminPermission[]> = {
  mounted: update,
  updated: update,
};
